import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { RaceInfoComponent } from '../../grid/content/race-info.component';

@Component({
    selector: 'ms-tree-race-info',
    templateUrl: 'tree-race-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconCustomComponent],
})
export class TreeRaceInfoComponent extends RaceInfoComponent {}
